<script type="text/ecmascript-6">
    import WbDesignerQuestionTechnicalProfile from "../wb/DesignerQuestionTechnicalProfile.vue";

    export default {
        mixins: [
            WbDesignerQuestionTechnicalProfile
        ],
        computed: {
            panel_required(){
                return Array.isArray(this.filtered_option_list);
            }
        },
    }
</script>
